import { Routes } from '@angular/router';

import { authGuard } from './guards/auth.guard';
import { loginGuard } from './guards/login.guard';
import { roleGuard } from './guards/role.guard';
import { UserRole } from './core/types/user.types';

export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () => import('./layouts/app-layout/app-layout.component').then(m => m.AppLayoutComponent),
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadComponent: () => import('./pages/dashboard/dashboard.component').then(m => m.DashboardComponent)
      },
      // Admin routes
      {
        path: 'enterprises',
        canActivate: [roleGuard([UserRole.Admin])],
        loadChildren: () => import('./features/enterprises/enterprises.routes').then(m => m.ENTERPRISES_ROUTES)
      },
      {
        path: 'departments',
        canActivate: [roleGuard([UserRole.Admin])],
        loadChildren: () => import('./features/departments/departments.routes').then(m => m.DEPARTMENTS_ROUTES)
      },
      {
        path: 'users',
        canActivate: [roleGuard([UserRole.Admin])],
        loadChildren: () => import('./features/users/users.routes').then(m => m.USERS_ROUTES)
      },
      // Dietitian routes
      {
        path: 'diets',
        canActivate: [roleGuard([UserRole.Admin, UserRole.Dietitian])],
        loadChildren: () => import('./features/diets/diets.routes').then(m => m.DIETS_ROUTES)
      },
      {
        path: 'dishes',
        canActivate: [roleGuard([UserRole.Admin, UserRole.Dietitian])],
        loadChildren: () => import('./features/dishes/dishes.routes').then(m => m.DISHES_ROUTES)
      },
      {
        path: 'ingredients',
        canActivate: [roleGuard([UserRole.Admin, UserRole.Dietitian])],
        loadChildren: () => import('./features/ingredients/ingredients.routes').then(m => m.INGREDIENTS_ROUTES)
      },
      {
        path: 'patient-categories',
        canActivate: [roleGuard([UserRole.Admin, UserRole.Dietitian])],
        loadChildren: () => import('./features/patient-categories/patient-categories.routes').then(m => m.PATIENT_CATEGORIES_ROUTES)
      },
      // Cyclic menu
      {
        path: 'cyclic-menu',
        canActivate: [roleGuard([UserRole.Admin, UserRole.Dietitian])],
        loadChildren: () => import('./features/cyclic-menu/cyclic-menu.routes').then(m => m.CYCLIC_MENU_ROUTES)
      },
      // Orders (Nurse + Admin)
      {
        path: 'orders',
        canActivate: [roleGuard([UserRole.Nurse, UserRole.SeniorNurse, UserRole.Admin, UserRole.Dietitian, UserRole.Warehouse])],
        loadChildren: () => import('./features/orders/orders.routes').then(m => m.ORDERS_ROUTES)
      },
      // Kitchen reports (Kitchen + Admin)
      {
        path: 'kitchen',
        canActivate: [roleGuard([UserRole.Kitchen, UserRole.Admin])],
        loadChildren: () => import('./features/kitchen/kitchen.routes').then(m => m.kitchenRoutes)
      },
      // Warehouse requests (Warehouse + Admin)
      {
        path: 'warehouse',
        loadChildren: () => import('./features/warehouse/warehouse.routes').then(m => m.WAREHOUSE_ROUTES)
      },
      // Audit Log (Admin only)
      {
        path: 'audit',
        canActivate: [roleGuard([UserRole.Admin])],
        loadChildren: () => import('./features/audit/audit.routes').then(m => m.AUDIT_ROUTES)
      },
      {
        path: 'analytics',
        canActivate: [roleGuard([UserRole.Admin])],
        loadChildren: () => import('./features/analytics/analytics.routes').then(m => m.ANALYTICS_ROUTES)
      },
      // Admin Settings (Admin only)
      {
        path: 'admin',
        canActivate: [roleGuard([UserRole.Admin])],
        loadChildren: () => import('./features/admin/admin.routes').then(m => m.adminRoutes)
      },
    ]
  },
  {
    path: 'sign-in',
    canActivate: [loginGuard],
    loadComponent: () => import('./pages/sign-in/sign-in.component').then(m => m.SignInComponent)
  },
  {
    path: '**',
    redirectTo: ''
  }
];
